import {
  Component,
  OnInit,
} from '@angular/core';
import { NavigationExtras } from '@angular/router';
import {
  ActivatedRoute,
  Router,
} from '@angular/router';
import { NavController } from '@ionic/angular';
// import { Storage } from '@ionic/storage';

// import { DataService } from '../../services/data.service';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-admin-product-list',
  templateUrl: './admin-product-list.component.html',
  styleUrls: ['../admin-category-list/admin-category-list.component.scss','./admin-product-list.component.scss'],
})
export class AdminProductListComponent implements OnInit {
  categorylist:any = [];	
  menulist:any = [];	
  select_value = 'All';
  check_box = false;
  constructor(public navCtrl: NavController,public DBservice: DataService,private router:Router) { }

  ngOnInit() {
  	this.get_categorylist()
  }

  ionViewWillEnter() {
    // this.get_categorylist();
  }
  
  get_categorylist() {

    var data = {
      domain:this.DBservice.domain
    }
    this.DBservice.get_categories(data).subscribe(data => {
        this.categorylist = data.message;
        // console.log(this.categorylist)
        // this.storage.set("get_all_category",data.message);
        this.getsearch();
      }, error => {
        console.log(JSON.stringify(error.json()));
      });
  }

  onCategoryChange(event){
    if(event.detail.value != 'All'){
      this.menulist= [];
      var categorylist = this.categorylist.filter(obj=>obj.product_category_name == event.detail.value);
      let val = document.getElementById(event.detail.value+'s') as HTMLInputElement
      val.scrollIntoView({ behavior: 'auto',block :'center' , inline :'center' })
      categorylist.map(res=>{
          res.products.map(value =>{
               this.menulist.push(value)
          })
        })
      // if(categorylist[0].products != undefined){
      //   for (var j = 0; j < categorylist[0].products.length; j++) {
      //     var v = j ;
      //     this.menulist.push(categorylist[0].products[v]);
      //   }
      // }
    }
    else
      this.getsearch()
  }

  getsearch() {
    this.menulist=[]
    this.categorylist.map(res=>{
         if(res.products && res.products.length != 0){
          res.products.map(value =>{
            this.menulist.push(value)
          })
         }
      })
  }

  open_product(title){
  	// let params: NavigationExtras = {
   //        queryParams: {'id': order_id},
   //        state: {'order_id': order_id, 'amount': amount, 'redirect_to': route, 'subscription_id': subscription_id}
   //      }
    //  this.navCtrl.navigateForward(['addproduct'], {});
    // this.navCtrl.navigateForward(['/my-profile/view-product/'], {});
    this.router.navigateByUrl('/my-profile/view-product');
  }

  edititem(value,index){
    // console.log("Value", value)
  //     let params: NavigationExtras = {
  //         queryParams: {'id': value.name}
  //  //        state: {'order_id': order_id, 'amount': amount, 'redirect_to': route, 'subscription_id': subscription_id}
  //       }
  //    this.navCtrl.navigateForward(['addproduct'], params);
  if(this.DBservice.ismobile){
    // let params: NavigationExtras = {
    //   queryParams: {'id': value.name}
    // }
    this.router.navigateByUrl('/addproduct/'+value.name);
    // this.navCtrl.navigateForward(['addproduct'], params)
  }else{
    this.router.navigateByUrl('/my-profile/view-product/'+value.name);
  } 
  }

  // onScroll(event: any) {
  //    console.log("Event", event)
  //    if(event.target.scrollTop <= 100){
  //       this.DBservice.scroll_top = true;
  //    }else{
  //       this.DBservice.scroll_top = false;
  //    }
  //  }

}
